<template>
  <div id="contenedor-registrar-nuevo-proyecto">
    <v-form
      ref="registrarProyecto">
      <v-row no-gutters>
        <v-col cols="12" class="my-3">
          <CustomTextArea
            v-model="proyecto.descripcion"
            label="Descripción"
            placeholder=""
            rows="2"
            :rules="[mixReglas.requerido]">
          </CustomTextArea>
        </v-col>
        <v-col v-if="false" cols="12">
          <div style="border: 1px solid #eee;" class="rounded-lg">
            <v-toolbar dense flat class="mx-1">
              Seleccionar responsables
              <v-chip class="ml-1" small color="primary">
                {{ responsablesSeleccionados.length }}
              </v-chip>
            </v-toolbar>
            <v-divider></v-divider>
            <div style="height: 250px;" class="overflow-y-auto">
            </div>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import OBRA from '@/graphql/querys/administracion/planeacion/obra.gql';
import OBRAS from '@/graphql/querys/administracion/planeacion/buscarObras.gql';
import AGREGAR_PROYECTO from '@/graphql/mutations/administracion/control-proyectos/agregarProyecto.gql';
import CustomTextArea from '@/components/inputs/sinColumnas/TextArea.vue';

export default {
  name: 'RegistrarNuevoProyecto',
  components: {
    CustomTextArea,
  },
  props: {
    idObra: {
      type: String,
      required: false,
    },
    filtros: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      responsablesSeleccionados: [],
      proyecto: {
        idObra: this.idObra,
        descripcion: null,
        responsables: [],
        documentos: [],
      },
    };
  },
  apollo: {
    obra: {
      query: OBRA,
      variables() {
        return {
          id: this.idObra,
        };
      },
      skip() {
        return !this.idObra;
      },
      result({ data }) {
        if (data && data.obra) {
          this.proyecto.descripcion = data.obra.meta;
        }
      },
    },
    firmasPorModulo: {
      query: FIRMAS_POR_MODULO,
      variables() {
        return {
          modulo: 'planeacion',
        };
      },
      result({ data }) {
        const firmanteResponsable = data.firmasPorModulo.find(
          (firmante) => firmante.orden === 1,
        );
        if (firmanteResponsable) {
          this.proyecto.responsables = [
            {
              idFuncionario: firmanteResponsable.idFuncionario,
              esLider: true,
            },
          ];
        }
      },
    },
  },
  computed: {
    getFuncionariosFirmantes() {
      if (!this.firmasPorModulo) return [];
      return this.firmasPorModulo;
    },
    getFirmanteResponsable() {
      return this.getFuncionariosFirmantes.find(
        (firmante) => firmante.orden === 1,
      );
    },
  },
  methods: {
    async guardar() {
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_PROYECTO,
          variables: {
            proyecto: this.proyecto,
          },
          update: (store, { data: { agregarProyecto } }) => {
            const query = {
              query: OBRAS,
              variables: {
                filtros: {
                  ejercicio: this.filtros.ejercicio,
                  buscar: this.filtros.buscar,
                  idTipo: this.filtros.idTipo,
                  idPrograma: this.filtros.idPrograma,
                  etiquetas: this.filtros.etiquetas,
                  incluirConContratos: this.filtros.incluirConContratos,
                  numeroRegistros: this.filtros.numeroRegistros,
                  pagina: this.filtros.pagina,
                },
              },
            };
            const data = store.readQuery(query);
            const { buscarObras } = data;
            const { obras } = buscarObras;
            const obraRegistrada = obras.find(({ id }) => id === this.idObra);

            if (obraRegistrada) {
              obraRegistrada.proyecto = agregarProyecto;
              const index = obras
                .findIndex((obra) => obra.id === this.idObra);
              if (index !== -1) {
                obras.splice(index, 1, obraRegistrada);
              }
              store.writeQuery({ ...query, data });
            }
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.mixEsCargando();
    },
    cancelar() {
      this.proyecto.idObra = null;
      this.proyecto.descripcion = null;
      this.proyecto.responsables = [];
      this.proyecto.documentos = [];
      this.responsablesSeleccionados = [];
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  watch: {
    responsablesSeleccionados: {
      handler(responsables) {
        this.proyecto.responsables = responsables.map(({ id }) => ({
          idFuncionario: id,
          esLider: false,
        }));
      },
    },
  },
};
</script>

<style lang="scss">

</style>
